<template>
  <div class="mob-services pt-3 pb-0">
    <div class="container hk-container-padding">
      <div class="row">
        <div class="col-12 ">
          <h2 class="hk-heading-text pt-4 pt-md-0 pt-lg-0 pb-4 pb-md-0 pb-lg-0 mb-0">
             {{ $t('services_page.text_our_services')}}
          </h2>
        </div>
      </div>
      <div id="hk-client-carousel" class="carousel carousel-fade slide pt-2" data-bs-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="row">
              <div class="col-12 col-md-5 col-lg-5 position-relative">
                <div class="testimonial-carousel-box">
                  <img src="@/assets/services/payment_processing.webp" alt="payment"  loading="lazy" class="w-100" />
                </div>
              </div>
              <div class="col-12 col-md-7 col-lg-7 position-relative">
                <blockquote>
                  <h2>{{ $t('services_page.payment_processing')}}</h2>
                  <p class="client-descrp">
                    {{ $t('services_page.payment_processing_text')}}
                  </p>
                </blockquote>
                <div class="pt-0">
                  <router-link class="btn px-4 py-2" :to="'/services'"> {{ $t('all_hk_btn.btn_read_more')}} </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item">
             <div class="row">
              <div class="col-12 col-md-5 col-lg-5 position-relative">
                <div class="testimonial-carousel-box">
                  <img src="@/assets/services/implementation.webp" alt="implementation"  loading="lazy" class="w-100" />
                </div>
              </div>
              <div class="col-12 col-md-7 col-lg-7 position-relative">
                <blockquote>
                  <h2>{{ $t('services_page.implementation')}}</h2>
                  <p class="client-descrp">
                    {{ $t('services_page.implementation_text')}}
                  </p>
                </blockquote>
                <div class="pt-0">
                  <router-link class="btn px-4 py-2" :to="'/services'"> {{ $t('all_hk_btn.btn_read_more')}} </router-link>
                </div>
                
              </div>
            </div>
          </div>
          <div class="carousel-item">
             <div class="row">
              <div class="col-12 col-md-5 col-lg-5 position-relative">
                <div class="testimonial-carousel-box">
                  <img src="@/assets/services/support.webp" alt="support"  loading="lazy" class="w-100" />
                </div>
              </div>
              <div class="col-12 col-md-7 col-lg-7 position-relative">
                <blockquote>
                  <h2>{{ $t('services_page.support')}}</h2>
                  <p class="client-descrp">
                    {{ $t('services_page.support_text')}}
                  </p>
                </blockquote>
                <div class="pt-0">
                  <router-link class="btn px-4 py-2" :to="'/services'"> {{ $t('all_hk_btn.btn_read_more')}} </router-link>
                </div>
                
              </div>
            </div>
          </div>
          <div class="carousel-item">
             <div class="row">
              <div class="col-12 col-md-5 col-lg-5 position-relative">
                <div class="testimonial-carousel-box">
                  <img src="@/assets/services/training.webp" alt="training"  loading="lazy" class="w-100"  />
                </div>
              </div>
              <div class="col-12 col-md-7 col-lg-7 position-relative">
                <blockquote>
                  <h2>{{ $t('services_page.training')}}</h2>
                  <p class="client-descrp">
                    {{ $t('services_page.training_text')}}
                  </p>
                </blockquote>
                <div class="pt-0">
                  <router-link class="btn px-4 py-2" :to="'/services'"> {{ $t('all_hk_btn.btn_read_more')}} </router-link>
                </div>
                
              </div>
            </div>
          </div>
          <div class="carousel-item">
             <div class="row">
              <div class="col-12 col-md-5 col-lg-5 position-relative">
                <div class="testimonial-carousel-box">
                  <img src="@/assets/services/interfaces.webp" alt="interface"  loading="lazy" class="w-100" />
                </div>
              </div>
              <div class="col-12 col-md-7 col-lg-7 position-relative">
                <blockquote>
                  <h2> {{ $t('services_page.interfaces')}}</h2>
                  <p class="client-descrp">
                    {{ $t('services_page.interfaces_text')}}
                  </p>
                </blockquote>
                <div class="pt-0">
                  <router-link class="btn px-4 py-2" :to="'/services'"> {{ $t('all_hk_btn.btn_read_more')}} </router-link>
                </div>
                
              </div>
            </div>
          </div>
        </div>
        <img src="@/assets/hk-platform/grid_left.svg" alt="grid left"  class="grid_left">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobServices",
  data() {
    return {};
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";
.mob-services {
  background: $white;
  .btn{
    font-size: 14px;
    color: $main-headings !important;
    border: 1px solid $main-headings;
    font-weight: 600;
  }
  .hk-heading-text{
    font-size: 1.5rem;
    color: $main-headings;
    font-weight: 800;
    letter-spacing: -0.48px;
    line-height: 32px;
    text-align: center;
  }

    h2{
      font-size: 1rem;
    font-weight: 800;
    letter-spacing: -0.32px;
    line-height: 24px;
    color: $main-headings;
    }
    blockquote{
      padding-top: 1rem;
    }
}

.hk-text-p {
  line-height: 1.8;
  letter-spacing: 0.09px;
  font-size: 18px;
  padding-bottom: 2rem;
  color: $p-color;
}
.client-img {
  width: 102px;
  height: 102px;
  margin-right: 15px;
}
.testimonial-carousel-box img{
  width: calc(100% - 100px) !important;
}
.testimonial-overflow {
  overflow: auto;
  height: calc(400px - 100px);
}
small {
  font-size: 1.5rem;
}
blockquote img{
  display: inline;
  width: 45px;
}

// .testimonial-carousel-box img{
//   padding:30px;
// }
.arrow-position{
    position: absolute;
    right: 0;
    // bottom: 30px;
    z-index: 1;
    width: 100px;
    height: 50px;
    border: 1px solid #000;
    background: $white;
}
.see-all{
  position: relative;
    top: 2rem;
    display: flex;
    align-items: center;
    padding-bottom: 3rem;
    padding-top: 1rem;
    img{
    width: 12px;
    margin-left: 1rem;
    margin-top: -5px;
    }
}
.see-all-text{
  font-size: 1.25rem;
  font-weight: 700;
}
.carousel-control-next, .carousel-control-prev{
  width: 50px;
}
.arrow-position .carousel-control-prev{
border-right:1px solid #000 ;
}
.client-descrp {
  color: $main-headings;
    line-height: 35px;
    font-size: 1.2rem;
    letter-spacing: 0px;
    padding-top: 2rem;
}
.carousel-control-prev-icon {
    background-image: url(@/assets/common/left-angel-arrow.svg);

}
.carousel-control-next-icon {
    background-image: url(@/assets/common/right-angel-arrow.svg);
}

.carousel-control-next, .carousel-control-prev{
  opacity: unset;
}
.carousel-control-next-icon, .carousel-control-prev-icon{
  width: 1rem;
  height: 1rem;
}
//.col-md-7.col-lg-7.position-relative{
  // blockquote{
  //   position: absolute;
  //   top: 0;
  // }
  // div{
  //   position: absolute;
  //   bottom: 0;
  // }
//}
@media (max-width: 575.98px) {
  .mob-services{
    padding-left: 5px;
    padding-right: 5px;
  }
  .testimonial-carousel-box img{
  width: 100%!important;
  border-radius: 15px;
}
blockquote {
  img {
    display: inline;
    width: 28px;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
}
.client-descrp{
  padding-top: 0px;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.28px;
}
}


.read-more-btn{
  font-size: 14px;
  img{
    width: 10px;
  }
}
.carousel-item{
z-index: 1;
}
.grid_left{
  position: absolute;
    top: -0.5rem;
    left: -2rem;
}
}
</style>
